// TODO fallback for types
import { CollectionName, CollectionToDtoMap, CollectionToSjMap } from './types';

export {
  /**
   * @deprecated Use
   */
  CollectionName,
  /**
   * @deprecated Use
   */
  type CollectionToDtoMap as CollectionsTypeValueMap,
};
/**
 * @deprecated Use CollectionToSjMap
 */
export type ICollections = CollectionToSjMap;
